import { get, deleteRequest, put, post } from './api'
import { getServerInfo } from '../utils/helpers/networkInfo.helper';

const serverUrl = getServerInfo('api');

export class ProgramService {
    static getAll(token, queryParams = {}) {
        return get(`${serverUrl}programs`, token, queryParams)
    }

    static getById(id, token) {
        return get(`${serverUrl}programs/${id}`, token)
    }

    static bulkDelete(ids, token) {
        return deleteRequest(`${serverUrl}programs`, { ids }, true, token)
    }

    static delete(id, token) {
        return deleteRequest(`${serverUrl}programs/${id}`, null, false, token)
    }

    static create(data, token) {
        return post(`${serverUrl}programs`, data, true, token)
    }

    static update(id, data, token) {
        return put(`${serverUrl}programs/${id}`, data, true, token)
    }
    
    static showCourses(id, token) {
        return get(`${serverUrl}programs/${id}/courses`, token);
    }

    static showLaboratories(id, token) {
        return get(`${serverUrl}programs/${id}/laboratories`, token);
    }

    static getProgramxEmptyCourse(token, queryParams = {}) {
        return get(`${serverUrl}coursesbyemptyprogram`, token, queryParams)
    }

}

